import { ComponentBase } from "../../core/ComponentBase.js";
import { avatarHelper } from "../../helpers/avatarHelper.js";

// ── helpers ───────────────────────────────────────────────────────────────────
function getGroupLabel(dateStr) {
    if (!dateStr) return 'Older';
    const d=new Date(dateStr), now=new Date(), diff=Math.floor((now-d)/86400000);
    if(diff===0) return 'Today'; if(diff===1) return 'Yesterday';
    if(diff<=6) return 'This Week'; if(diff<=29) return 'This Month';
    return 'Older';
}
function formatTime(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr), now = new Date(), diff = now - d;
    if (diff < 60000) return 'now';
    if (diff < 3600000) return `${Math.floor(diff/60000)}m`;
    if (d.toDateString() === now.toDateString()) return d.toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'});
    const yest = new Date(now); yest.setDate(now.getDate()-1);
    if (d.toDateString() === yest.toDateString()) return 'Yesterday';
    if (diff < 7*86400000) return d.toLocaleDateString([],{weekday:'short'});
    return d.toLocaleDateString([],{month:'short',day:'numeric'});
}
function avatarColor(str) {
    const p=['#3B82F6','#10B981','#F59E0B','#EF4444','#8B5CF6','#06B6D4','#F97316','#14B8A6','#EC4899','#6366F1'];
    let h=0; for(let i=0;i<(str||'').length;i++) h=(h*31+str.charCodeAt(i))|0;
    return p[Math.abs(h)%p.length];
}
function initials(name) {
    const p=(name||'?').trim().split(/\s+/);
    return p.length>=2?(p[0][0]+p[p.length-1][0]).toUpperCase():(name||'?').slice(0,2).toUpperCase();
}
const GROUP_ORDER = ['Today','Yesterday','This Week','This Month','Older'];

export class WorkspaceSidebar extends ComponentBase {
    static styles = `
        /* ── shell ─────────────────────────────────────────────────────────── */
        .ws-sidebar {
            display: flex; flex-direction: column; height: 100%;
            background: var(--bs-tertiary-bg);
            overflow: hidden;
        }

        /* ── header ─────────────────────────────────────────────────────────── */
        .ws-sb-header {
            padding: 1rem 1rem 0.75rem;
            display: flex; flex-direction: column; gap: 0.65rem;
            flex-shrink: 0;
        }
        .ws-sb-top {
            display: flex; align-items: center; justify-content: space-between;
        }
        .ws-sb-title {
            font-size: var(--ab-label-size);
            font-weight: var(--ab-label-weight);
            letter-spacing: var(--ab-label-spacing);
            text-transform: uppercase;
            color: var(--ab-label-color);
            margin: 0;
        }
        /* New-chat button in top-right */
        .ws-new-btn, #sb-close-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: var(--ab-ctrl-sm);
            height: var(--ab-ctrl-sm);
            border-radius: var(--ab-radius-sm);
            border: none;
            background: transparent;
            color: var(--bs-secondary-color);
            cursor: pointer;
            transition: background-color var(--ab-t-fast), color var(--ab-t-fast);
        }
        @media (hover: hover) {
            .ws-new-btn:hover, #sb-close-btn:hover {
                background-color: var(--ab-hover-bg);
                color: var(--bs-body-color);
            }
        }
        .ws-new-btn:focus-visible, #sb-close-btn:focus-visible {
            outline: none;
            box-shadow: var(--ab-focus-ring);
        }
        #sb-close-btn {
            display: none !important;
        }
        @media (max-width: 768px) {
            #sb-close-btn {
                display: inline-flex !important;
            }
        }


        /* ── search ─────────────────────────────────────────────────────────── */
        .ws-sb-search-wrap {
            position: relative;
        }
        .ws-sb-search-wrap i {
            position: absolute; left: 0.6rem; top: 50%; transform: translateY(-50%);
            color: var(--bs-secondary-color); font-size: var(--ab-text-sm); pointer-events: none;
        }
        .ws-sb-search {
            width: 100%; border: 1px solid var(--bs-border-color-translucent);
            border-radius: var(--ab-radius-sm); background: var(--bs-body-bg);
            padding: 0.45rem 0.6rem 0.45rem 1.8rem;
            font-size: var(--ab-text-sm); color: var(--bs-body-color);
            outline: none; transition: border-color var(--ab-t-base), box-shadow var(--ab-t-base);
        }
        .ws-sb-search:focus-visible {
            border-color: var(--ab-focus-border);
            box-shadow: var(--ab-focus-ring);
        }
        .ws-sb-search::placeholder { color: var(--bs-secondary-color); opacity: 0.6; }

        /* ── unified search results overlay ──────────────────────────────────── */
        .ws-sb-search-results {
            position: fixed;
            background: var(--bs-body-bg);
            border: 1px solid var(--bs-border-color-translucent);
            border-radius: var(--ab-radius-md);
            box-shadow: var(--ab-shadow-lg);
            z-index: var(--ab-z-modal); max-height: 320px; overflow-y: auto;
            min-width: 220px;
        }
        .ws-sr-section {
            font-size: var(--ab-label-size); font-weight: var(--ab-label-weight); letter-spacing: var(--ab-label-spacing);
            text-transform: uppercase; color: var(--ab-label-color);
            padding: 0.5rem 0.75rem 0.2rem; opacity: 0.7;
        }
        .ws-sr-item {
            display: flex; align-items: center; padding: 0.5rem 0.75rem;
            cursor: pointer; transition: background-color var(--ab-t-fast), color var(--ab-t-fast); font-size: var(--ab-text-sm);
            overflow: hidden;
            border-radius: var(--ab-radius-sm);
        }
        @media (hover: hover) {
            .ws-sr-item:hover { background: var(--ab-hover-bg); }
        }
        .ws-sr-item:focus-visible {
            outline: none;
            box-shadow: var(--ab-focus-ring);
        }
        .ws-sr-name { font-weight: var(--ab-weight-medium); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; }
        .ws-sr-preview { font-size: var(--ab-text-xs); color: var(--bs-secondary-color); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; margin-left: 4px; }
        .ws-sr-loading { padding: 0.6rem 0.75rem; font-size: var(--ab-text-sm); color: var(--bs-secondary-color); }

        /* ── agent filter dropdown ───────────────────────────────────────────── */
        .ws-sb-agent-select {
            width: 100%;
            font-size: var(--ab-text-sm);
            padding: 0.35rem 0.6rem;
            border: 1px solid var(--bs-border-color-translucent);
            border-radius: var(--ab-radius-sm);
            background: var(--bs-body-bg);
            color: var(--bs-body-color);
            outline: none;
            cursor: pointer;
            transition: border-color var(--ab-t-base), box-shadow var(--ab-t-base);
            appearance: auto;
        }
        .ws-sb-agent-select:focus-visible {
            border-color: var(--ab-focus-border);
            box-shadow: var(--ab-focus-ring);
        }

        /* ── thread list ─────────────────────────────────────────────────────── */
        .ws-sb-list {
            flex-grow: 1; overflow-y: auto; padding: 0.05rem 0.5rem 1rem;
            list-style: none; margin: 0;
            /* custom scrollbar */
            scrollbar-width: thin;
            scrollbar-color: var(--bs-border-color-translucent) transparent;
        }
        .ws-sb-list::-webkit-scrollbar { width: 4px; }
        .ws-sb-list::-webkit-scrollbar-track { background: transparent; }
        .ws-sb-list::-webkit-scrollbar-thumb {
            background: var(--bs-border-color-translucent); border-radius: var(--ab-radius-pill);
        }

        /* ── date group label ────────────────────────────────────────────────── */
        .ws-sb-group-label {
            padding: 0.65rem 0.5rem 0.25rem;
            font-size: var(--ab-label-size); font-weight: var(--ab-label-weight); letter-spacing: var(--ab-label-spacing);
            text-transform: uppercase; color: var(--ab-label-color);
            opacity: 0.55; user-select: none;
        }

        /* ── horizontal filter chips ────────────────────────────────────────── */
        .ws-sb-filters-row {
            display: flex; gap: 0.4rem; padding: 0 1rem 0.35rem;
            overflow-x: auto; scrollbar-width: none; flex-shrink: 0;
        }
        .ws-sb-filters-row::-webkit-scrollbar { display: none; }
        .ws-filter-chip {
            background: var(--bs-secondary-bg);
            border: 1px solid var(--bs-border-color-translucent);
            color: var(--bs-secondary-color);
            padding: 0.3rem 0.75rem; border-radius: var(--ab-radius-pill);
            font-size: var(--ab-text-xs); font-weight: var(--ab-weight-medium); cursor: pointer;
            white-space: nowrap; transition: background-color var(--ab-t-base), color var(--ab-t-base), border-color var(--ab-t-base);
        }
        @media (hover: hover) {
            .ws-filter-chip:hover {
                background: var(--ab-hover-bg);
                color: var(--bs-body-color);
            }
        }
        .ws-filter-chip:focus-visible {
            outline: none;
            box-shadow: var(--ab-focus-ring);
        }
        .ws-filter-chip.active {
            background: var(--ab-active-bg);
            border-color: var(--ab-active-border, var(--bs-primary));
            color: var(--ab-active-color);
            font-weight: var(--ab-weight-semibold);
        }

        /* ── individual thread item ──────────────────────────────────────────── */
        .ws-thread-item {
            display: flex; align-items: center; gap: 0.75rem;
            padding: 0.65rem 0.8rem;
            border-radius: var(--ab-radius-md); margin-bottom: 2px;
            cursor: pointer; position: relative;
            transition: background-color var(--ab-t-base), color var(--ab-t-base);
            color: var(--bs-body-color);
        }
        @media (hover: hover) {
            .ws-thread-item:hover { background: var(--ab-hover-bg); }
        }
        .ws-thread-item:focus-visible {
            outline: none;
            box-shadow: var(--ab-focus-ring);
        }
        .ws-thread-item.active {
            background: var(--ab-active-bg);
            color: var(--ab-active-color);
        }

        /* Avatar circle and type badges */
        .ws-ti-av-container {
            position: relative; flex-shrink: 0;
        }
        .ws-ti-av {
            width: 44px; height: 44px; border-radius: var(--ab-radius-full);
            display: flex; align-items: center; justify-content: center;
            font-size: var(--ab-text-sm); font-weight: 700; color: #fff;
            position: relative;
        }
        .ws-ti-av i { font-size: var(--ab-text-lg); }

        @keyframes pulseGreen {
            0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7); }
            70% { box-shadow: 0 0 0 6px rgba(40, 167, 69, 0); }
            100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
        }
        .ws-ti-av.streaming {
            animation: pulseGreen 1.5s infinite;
            border: 2px solid var(--bs-success) !important;
        }

        /* Type badge overlay at bottom-right of avatar */
        .ws-ti-type-badge {
            position: absolute; bottom: -2px; right: -2px;
            width: 17px; height: 17px; border-radius: var(--ab-radius-full);
            background: var(--bs-body-bg);
            border: 1.5px solid var(--bs-tertiary-bg);
            display: flex; align-items: center; justify-content: center;
            font-size: var(--ab-text-2xs); color: var(--bs-secondary-color);
            box-shadow: var(--ab-shadow-xs);
        }
        .ws-thread-item.active .ws-ti-type-badge {
            border-color: rgba(var(--bs-primary-rgb), 0.15);
        }

        /* Structured Dual-Row Body Layout */
        .ws-ti-body {
            flex-grow: 1; min-width: 0;
            display: flex; flex-direction: column; gap: 0.15rem;
        }

        .ws-ti-title-row {
            display: flex; align-items: center; justify-content: space-between;
            gap: 0.5rem;
        }
        .ws-ti-title {
            font-size: var(--ab-text-base); font-weight: var(--ab-weight-semibold);
            white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
            color: var(--bs-body-color); flex-grow: 1;
        }
        .ws-thread-item.active .ws-ti-title { color: var(--ab-active-color); }

        .ws-ti-time {
            font-size: var(--ab-text-2xs); color: var(--bs-secondary-color);
            white-space: nowrap; opacity: 0.85;
        }

        .ws-ti-preview-row {
            display: flex; align-items: center; justify-content: space-between;
            gap: 0.5rem;
        }
        .ws-ti-preview {
            font-size: var(--ab-text-xs); color: var(--bs-secondary-color);
            white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
            opacity: 0.75; flex-grow: 1; min-width: 0;
        }

        /* Fixed Right-Aligned Meta Group (No overlap, no dynamic hiding!) */
        .ws-ti-meta-right {
            display: flex; align-items: center; gap: 0.35rem; flex-shrink: 0;
        }
        .ws-ti-pin-icon {
            color: var(--bs-secondary-color); font-size: var(--ab-text-xs); opacity: 0.7;
        }
        .ws-ti-star-icon {
            color: #FFC107; font-size: var(--ab-text-xs);
        }
        .ws-ti-unread {
            background-color: var(--bs-primary);
            color: #fff; border-radius: var(--ab-radius-pill);
            padding: 0.12rem 0.4rem;
            font-size: var(--ab-text-2xs); font-weight: var(--ab-weight-bold);
            line-height: 1.1; display: inline-flex;
            align-items: center; justify-content: center;
            min-width: 17px; height: 17px;
        }

        /* Three-dots menu trigger */
        .ws-ti-menu-trigger {
            background: none; border: none; padding: 0;
            color: var(--bs-secondary-color); cursor: pointer;
            width: 24px; height: 24px; border-radius: var(--ab-radius-full);
            display: flex; align-items: center; justify-content: center;
            font-size: var(--ab-text-sm); transition: background-color var(--ab-t-fast), color var(--ab-t-fast);
            opacity: 0; pointer-events: none;
        }
        .ws-thread-item:hover .ws-ti-menu-trigger,
        .ws-thread-item.active .ws-ti-menu-trigger,
        .ws-ti-menu-trigger.active {
            opacity: 0.8; pointer-events: auto;
        }
        @media (hover: hover) {
            .ws-ti-menu-trigger:hover {
                background-color: var(--ab-hover-bg);
                color: var(--bs-primary); opacity: 1 !important;
            }
        }
        .ws-ti-menu-trigger:focus-visible {
            outline: none;
            box-shadow: var(--ab-focus-ring);
            opacity: 1 !important;
            pointer-events: auto;
        }

        /* Dropdown custom absolutely-positioned context menu style */
        .ws-ti-context-menu {
            position: absolute; z-index: var(--ab-z-dropdown);
            background: var(--bs-body-bg);
            border: 1px solid var(--bs-border-color-translucent);
            border-radius: var(--ab-radius-md);
            box-shadow: var(--ab-shadow-lg);
            padding: 0.3rem 0; width: 140px;
            display: flex; flex-direction: column;
            animation: sbFadeIn 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .ws-menu-item {
            background: none; border: none; text-align: left;
            padding: 0.4rem 0.8rem; font-size: var(--ab-text-xs);
            color: var(--bs-body-color); cursor: pointer;
            display: flex; align-items: center; gap: 0.5rem;
            transition: background-color var(--ab-t-fast);
            width: 100%;
            border-radius: var(--ab-radius-sm);
        }
        @media (hover: hover) {
            .ws-menu-item:hover {
                background-color: var(--ab-hover-bg);
            }
        }
        .ws-menu-item:focus-visible {
            outline: none;
            box-shadow: var(--ab-focus-ring);
        }
        .ws-menu-item i {
            font-size: var(--ab-text-sm); width: 16px; opacity: 0.75;
        }

        /* Rename input */
        .ws-rename-input {
            width: 100%; padding: 0.25rem 0.5rem; font-size: var(--ab-text-sm);
            border: 1px solid var(--bs-primary); border-radius: var(--ab-radius-sm); outline: none;
            background: var(--bs-body-bg); color: var(--bs-body-color);
        }

        /* ── empty / loading state ───────────────────────────────────────────── */
        .ws-sb-empty {
            text-align: center; padding: 2rem 1rem;
            color: var(--bs-secondary-color); font-size: var(--ab-text-sm);
            display: flex; flex-direction: column; align-items: center; gap: 0.5rem;
        }
        .ws-sb-empty i { font-size: var(--ab-text-lg); opacity: 0.3; }



        /* ── search results panel (covers thread list) ──────────────────────── */
        .ws-sb-search-panel {
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: var(--bs-tertiary-bg);
            z-index: var(--ab-z-raised);
            display: flex; flex-direction: column;
            overflow: hidden;
            opacity: 0; pointer-events: none;
            transition: opacity 0.15s ease;
        }
        .ws-sb-search-panel.active {
            opacity: 1; pointer-events: auto;
        }
        .ws-sb-search-panel-inner {
            flex: 1; overflow-y: auto;
            padding: 0.25rem 0.5rem 1rem;
            scrollbar-width: thin;
            scrollbar-color: var(--bs-border-color-translucent) transparent;
        }
        .ws-sb-search-panel-inner::-webkit-scrollbar { width: 4px; }
        .ws-sb-search-panel-inner::-webkit-scrollbar-track { background: transparent; }
        .ws-sb-search-panel-inner::-webkit-scrollbar-thumb {
            background: var(--bs-border-color-translucent); border-radius: var(--ab-radius-pill);
        }
        .ws-sb-sr-label {
            padding: 0.65rem 0.5rem 0.25rem;
            font-size: var(--ab-label-size); font-weight: var(--ab-label-weight); letter-spacing: var(--ab-label-spacing);
            text-transform: uppercase; color: var(--ab-label-color);
            opacity: 0.55; user-select: none;
        }
        .ws-sb-sr-conv {
            display: flex; align-items: center; gap: 0.5rem;
            padding: 0.55rem 0.6rem;
            border-radius: var(--ab-radius-md); margin-bottom: 1px;
            cursor: pointer; transition: background-color var(--ab-t-base);
            font-size: var(--ab-text-base);
        }
        @media (hover: hover) {
            .ws-sb-sr-conv:hover { background: var(--ab-hover-bg); }
        }
        .ws-sb-sr-conv.active { background: var(--ab-active-bg); }
        .ws-sb-sr-conv.active .ws-sb-sr-conv-name { color: var(--ab-active-color); }
        .ws-sb-sr-conv-av {
            width: 40px; height: 40px; border-radius: var(--ab-radius-full); flex-shrink: 0;
            display: flex; align-items: center; justify-content: center;
            font-size: var(--ab-text-xs); font-weight: var(--ab-weight-bold); color: #fff;
        }
        .ws-sb-sr-conv-av i { font-size: var(--ab-text-md); }
        .ws-sb-sr-conv-body { flex: 1; min-width: 0; }
        .ws-sb-sr-conv-name { font-weight: var(--ab-weight-semibold); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .ws-sb-sr-conv-preview { font-size: var(--ab-text-xs); color: var(--bs-secondary-color); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; opacity: 0.75; }
        .ws-sb-sr-msg {
            display: flex; align-items: flex-start; gap: 0.5rem;
            padding: 0.5rem 0.6rem;
            border-radius: var(--ab-radius-sm); margin-bottom: 1px;
            cursor: pointer; transition: background-color var(--ab-t-base);
        }
        @media (hover: hover) {
            .ws-sb-sr-msg:hover { background: var(--ab-hover-bg); }
        }
        .ws-sb-sr-msg.active { background: var(--ab-active-bg); }
        .ws-sb-sr-msg-body { flex: 1; min-width: 0; }
        .ws-sb-sr-msg-thread { font-size: var(--ab-text-2xs); color: var(--bs-primary); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: var(--ab-weight-medium); }
        .ws-sb-sr-msg-text { font-size: var(--ab-text-xs); color: var(--bs-body-color); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; opacity: 0.8; }
        .ws-sb-sr-empty {
            text-align: center; padding: 2.5rem 1rem;
            color: var(--bs-secondary-color); font-size: var(--ab-text-sm);
        }
        .ws-sb-sr-empty i { font-size: var(--ab-text-lg); opacity: 0.3; display: block; margin-bottom: 0.4rem; }
        .ws-sb-sr-searching {
            padding: 1.5rem; text-align: center;
            font-size: var(--ab-text-sm); color: var(--bs-secondary-color);
        }
        @keyframes sbFadeIn {
            from { opacity: 0; transform: translateY(4px); }
            to   { opacity: 1; transform: translateY(0); }
        }
        .ws-thread-item { animation: sbFadeIn 0.18s ease-out both; }
    `;

    constructor(config) {
        super(config);
        this.workspace       = config.workspace;
        this.allThreads      = [];
        this.filteredThreads = [];
        this.editingThreadId = null;
        this.searchQuery     = '';
        this.activeFilter    = 'all';
        this.agentFilter     = '';
        this._agentColors    = {};  // agentName → color var
        this._boundHandleChatEvent = this._onChatEvent.bind(this);
        this._boundHandleAgentAvatarUpdated = this._handleAgentAvatarUpdated.bind(this);
        this.applyStyles();
    }

    async initialize() {
        this.appClient.events.server.on('chatEvent', this._boundHandleChatEvent);
        this.appClient.events.local.on('AGENT_AVATAR_UPDATED', this._boundHandleAgentAvatarUpdated);
        await super.initialize();
    }

    // Deterministic accent per agent name
    _dotColorFor(agentName) {
        const palette = [
            'var(--bs-primary)', 'var(--bs-success)', 'var(--bs-info)',
            'var(--bs-warning)', 'var(--bs-danger)', 'var(--bs-secondary)',
        ];
        if (!this._agentColors[agentName]) {
            const idx = Object.keys(this._agentColors).length % palette.length;
            this._agentColors[agentName] = palette[idx];
        }
        return this._agentColors[agentName];
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'ws-sidebar';

            // ── Header ──────────────────────────────────────────────────────
            const header = document.createElement('div');
            header.className = 'ws-sb-header';
            header.innerHTML = `
                <div class="ws-sb-top">
                    <h6 class="ws-sb-title">Conversations</h6>
                    <div class="d-flex align-items-center gap-2">
                        <button class="ws-new-btn" id="sb-new-icon" title="New conversation (Ctrl+Alt+N)">
                            <i class="bi bi-pencil-square"></i>
                        </button>
                        <button id="sb-close-btn" title="Close sidebar">
                            <i class="bi bi-x-lg"></i>
                        </button>
                    </div>
                </div>
                <div class="ws-sb-search-wrap" style="position:relative; display:flex; align-items:center;">
                    <i class="bi bi-search" id="sb-search-left-icon" style="position:absolute; left:0.6rem; top:50%; transform:translateY(-50%); font-size:var(--ab-text-sm); color:var(--bs-secondary-color); transition: color 0.15s, transform 0.15s; z-index:6; cursor:default;"></i>
                    <input class="ws-sb-search" id="sb-search" type="text" placeholder="Search conversations…" autocomplete="off" style="padding-right:2.2rem; padding-left:1.8rem; width:100%;">
                    <button id="sb-search-clear" title="Clear search" style="position:absolute; right:0.65rem; top:50%; transform:translateY(-50%); background:none; border:none; padding:0; cursor:pointer; display:none; align-items:center; justify-content:center; width:1.25rem; height:1.25rem; z-index:5;">
                        <i class="bi bi-x-circle-fill" style="position:static; transform:none; font-size:var(--ab-text-sm); color:var(--bs-secondary-color); opacity:0.7;"></i>
                    </button>
                </div>
            `;

            // Horizontal scrollable filter chips
            const filtersRow = document.createElement('div');
            filtersRow.className = 'ws-sb-filters-row';
            filtersRow.innerHTML = `
                <button class="ws-filter-chip active" data-filter="all">All</button>
                <button class="ws-filter-chip" data-filter="unread">Unread</button>
                <button class="ws-filter-chip" data-filter="direct">Direct</button>
                <button class="ws-filter-chip" data-filter="groups">Groups</button>
                <button class="ws-filter-chip" data-filter="agents">Agents</button>
                <button class="ws-filter-chip" data-filter="starred">Starred</button>
                <button class="ws-filter-chip" data-filter="archived">Archived</button>
            `;
            filtersRow.querySelectorAll('.ws-filter-chip').forEach(btn => {
                btn.addEventListener('click', () => {
                    filtersRow.querySelectorAll('.ws-filter-chip').forEach(b => b.classList.remove('active'));
                    btn.classList.add('active');
                    this.activeFilter = btn.dataset.filter;
                    this._applyFilters();
                });
            });
            header.appendChild(filtersRow);
            this.container.appendChild(header);

            // ── Thread list wrapper (position:relative so search panel can overlay it)
            const listWrapper = document.createElement('div');
            listWrapper.style.cssText = 'position:relative;flex:1;display:flex;flex-direction:column;overflow:hidden;';

            this.listEl = document.createElement('ul');
            this.listEl.className = 'ws-sb-list';
            this.listEl.id = 'thread-list';
            listWrapper.appendChild(this.listEl);

            // ── Search results panel (sits on top of thread list when active)
            this.searchPanelEl = document.createElement('div');
            this.searchPanelEl.className = 'ws-sb-search-panel';
            this.searchPanelEl.innerHTML = '<div class="ws-sb-search-panel-inner"></div>';
            listWrapper.appendChild(this.searchPanelEl);
            this._searchInner = this.searchPanelEl.querySelector('.ws-sb-search-panel-inner');

            this.container.appendChild(listWrapper);

            // ── Events ──────────────────────────────────────────────────────
            header.querySelector('#sb-new-icon').addEventListener('click', () => {
                this.appClient.events.fireLocal('SHOW_CONTACT_PICKER');
            });

            header.querySelector('#sb-close-btn')?.addEventListener('click', () => {
                this.workspace.toggleSidebar(false);
            });

            // ── Unified search: panel covers thread list ─────────────────────
            const searchInput = header.querySelector('#sb-search');
            header.querySelector('#sb-search-results')?.remove();

            const _hidePanel = () => {
                this.searchPanelEl.classList.remove('active');
                this._searchInner.innerHTML = '';
                const clearBtn = header.querySelector('#sb-search-clear');
                if (clearBtn) clearBtn.style.display = 'none';
            };

            const _showSearchResults = async (q) => {
                if (!q) { _hidePanel(); return; }

                this.searchPanelEl.classList.add('active');
                this._searchInner.innerHTML = '<div class="ws-sb-sr-searching"><span class="spinner-border spinner-border-sm text-primary me-2" role="status"></span>Searching…</div>';

                // 1. Conversation matches — instant local filter
                const convMatches = (this.allThreads || []).filter(t =>
                    (t.title||'').toLowerCase().includes(q) ||
                    (t.groupName||'').toLowerCase().includes(q) ||
                    (t.agentName||'').toLowerCase().includes(q)
                ).slice(0, 10);

                // 2. Cross-thread message search
                let msgMatches = [];
                try {
                    const res = await this.appClient.rpcClient.call(
                        'ChatRpc.searchMessages',
                        { query: q, pageSize: 6 },
                        { projectId: this.workspace.currentProjectId }
                    );
                    msgMatches = res.results || [];
                } catch (_) {/* non-critical */}

                if (!this.searchPanelEl.classList.contains('active')) return;

                this._searchInner.innerHTML = '';

                if (convMatches.length === 0 && msgMatches.length === 0) {
                    this._searchInner.innerHTML = `<div class="ws-sb-sr-empty"><i class="bi bi-search"></i>No results for "${this.escapeHtml(q)}"</div>`;
                    return;
                }

                if (convMatches.length > 0) {
                    const label = document.createElement('div');
                    label.className = 'ws-sb-sr-label';
                    label.textContent = 'Conversations';
                    this._searchInner.appendChild(label);

                    convMatches.forEach(t => {
                        const isGroup = (t.members?.length || 0) > 1 || t.type === 'group' || t.type === 'ai_human';
                        const displayName = (isGroup && t.groupName) ? t.groupName : t.title;
                        const isActive = this.workspace.currentThreadId === t._id;

                        // Build same avatar as thread list
                        let avHtml;
                        if (!isGroup && (t.members?.length || 0) <= 1) {
                            avHtml = `<div class="ws-sb-sr-conv-av" style="background:rgba(var(--bs-primary-rgb),0.8);"><i class="bi bi-robot"></i></div>`;
                        } else if (isGroup) {
                            const bg = avatarColor(t._id);
                            avHtml = `<div class="ws-sb-sr-conv-av" style="background:${bg};">${initials(displayName||'G')}</div>`;
                        } else {
                            const other = (t.members||[]).find(m => m.participantType === 'user');
                            const bg = avatarColor(other?.participantId || t._id);
                            avHtml = `<div class="ws-sb-sr-conv-av" style="background:${bg};">${initials(other?.displayName || displayName)}</div>`;
                        }

                        const preview = t.lastMessagePreview ? this.escapeHtml(t.lastMessagePreview.slice(0, 45)) : (t.agentName ? this.escapeHtml(t.agentName) : '');

                        const row = document.createElement('div');
                        row.className = 'ws-sb-sr-conv' + (isActive ? ' active' : '');
                        row.innerHTML = `${avHtml}<div class="ws-sb-sr-conv-body"><div class="ws-sb-sr-conv-name">${this.escapeHtml(displayName)}</div><div class="ws-sb-sr-conv-preview">${preview}</div></div>`;
                        row.addEventListener('mousedown', (e) => {
                            e.preventDefault();
                            this._searchInner.querySelectorAll('.ws-sb-sr-conv').forEach(r => r.classList.remove('active'));
                            row.classList.add('active');
                            this.workspace.loadThread(t._id);
                            // Highlight in the underlying thread list
                            this.updateSelection(t._id);
                        });
                        this._searchInner.appendChild(row);
                    });
                }

                if (msgMatches.length > 0) {
                    const label = document.createElement('div');
                    label.className = 'ws-sb-sr-label';
                    label.textContent = 'Messages';
                    this._searchInner.appendChild(label);

                    msgMatches.forEach(m => {
                        const thread = (this.allThreads||[]).find(t => t._id === m.threadId);
                        const threadName = thread?.groupName || thread?.title || 'Conversation';
                        const rawText = m.content || (Array.isArray(m.parts) && m.parts[0]?.text) || m.text || '';
                        const snippet = rawText.replace(/\s+/g, ' ').trim().slice(0, 80);

                        const row = document.createElement('div');
                        row.className = 'ws-sb-sr-msg';
                        row.innerHTML = `<i class="bi bi-chat-text ws-sb-sr-msg-icon" style="font-size:var(--ab-text-xs);color:var(--bs-secondary-color);flex-shrink:0;margin-top:2px;"></i>` +
                            `<div class="ws-sb-sr-msg-body">` +
                            `<div class="ws-sb-sr-msg-thread">${this.escapeHtml(threadName)}</div>` +
                            `<div class="ws-sb-sr-msg-text">${this.escapeHtml(snippet)}</div>` +
                            `</div>`;
                        row.addEventListener('mousedown', (e) => {
                            e.preventDefault();
                            this._searchInner.querySelectorAll('.ws-sb-sr-msg').forEach(r => r.classList.remove('active'));
                            row.classList.add('active');
                            // Signal loadHistory to jump to this specific message after rendering
                            this.workspace._pendingMessageJump = m._id;
                            this.workspace.loadThread(m.threadId);
                            this.updateSelection(m.threadId);
                        });
                        this._searchInner.appendChild(row);
                    });
                }
            };

            const leftIcon = header.querySelector('#sb-search-left-icon');
            const clearBtn = header.querySelector('#sb-search-clear');

            const _updateSearchUI = () => {
                const q = searchInput.value.trim().toLowerCase();
                const isActive = this.searchPanelEl.classList.contains('active') || document.activeElement === searchInput || q;
                if (isActive) {
                    if (leftIcon) {
                        leftIcon.className = 'bi bi-arrow-left';
                        leftIcon.style.color = 'var(--bs-primary)';
                        leftIcon.style.cursor = 'pointer';
                    }
                    if (q) {
                        if (clearBtn) clearBtn.style.display = 'flex';
                    } else {
                        if (clearBtn) clearBtn.style.display = 'none';
                    }
                } else {
                    if (leftIcon) {
                        leftIcon.className = 'bi bi-search';
                        leftIcon.style.color = 'var(--bs-secondary-color)';
                        leftIcon.style.cursor = 'default';
                    }
                    if (clearBtn) clearBtn.style.display = 'none';
                }
            };

            if (leftIcon) {
                leftIcon.addEventListener('click', (e) => {
                    if (leftIcon.classList.contains('bi-arrow-left')) {
                        e.preventDefault();
                        searchInput.value = '';
                        _hidePanel();
                        searchInput.blur();
                        _updateSearchUI();
                    }
                });
            }

            if (clearBtn) {
                clearBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    searchInput.value = '';
                    _hidePanel();
                    searchInput.focus();
                    _updateSearchUI();
                });
            }

            let _searchTimer;
            searchInput.addEventListener('input', (e) => {
                clearTimeout(_searchTimer);
                const q = e.target.value.trim().toLowerCase();
                _updateSearchUI();
                if (!q) {
                    _hidePanel();
                    return;
                }
                _searchTimer = setTimeout(() => _showSearchResults(q), 220);
            });

            searchInput.addEventListener('focus', () => _updateSearchUI());
            searchInput.addEventListener('blur', () => {
                setTimeout(() => _updateSearchUI(), 180);
            });

            searchInput.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    searchInput.value = '';
                    _hidePanel();
                    searchInput.blur();
                    _updateSearchUI();
                }
            });

            // Close when clicking outside the sidebar entirely
            document.addEventListener('mousedown', (e) => {
                if (this.container && !this.container.contains(e.target)) {
                    searchInput.value = '';
                    _hidePanel();
                    _updateSearchUI();
                }
            });

            if (this.workspace.currentProjectId) {
                this.loadThreads(this.workspace.currentProjectId);
            }
        }



        this._applyFilters();
        return this.container;
    }


    _getCurrentUserId() {
        const user = this.workspace.appClient?.getSharedData('user') || this.appClient?.getSharedData('user');
        return user?.id || user?._id || 'anonymous';
    }

    isPinned(threadId) {
        const thread = this.allThreads.find(t => t._id === threadId);
        return thread ? !!thread.isPinned : false;
    }
    async togglePin(threadId) {
        const thread = this.allThreads.find(t => t._id === threadId);
        if (!thread) return;
        const newState = !thread.isPinned;
        thread.isPinned = newState; // Optimistic update
        this._applyFilters();
        try {
            await this.appClient.rpcClient.call('ThreadRpc.setUserState', {
                threadId,
                preferences: { isPinned: newState }
            });
        } catch (err) {
            this.log.error("Failed to persist pin state", err);
            thread.isPinned = !newState; // Rollback
            this._applyFilters();
        }
    }

    isStarred(threadId) {
        const thread = this.allThreads.find(t => t._id === threadId);
        return thread ? !!thread.isStarred : false;
    }
    async toggleStar(threadId) {
        const thread = this.allThreads.find(t => t._id === threadId);
        if (!thread) return;
        const newState = !thread.isStarred;
        thread.isStarred = newState; // Optimistic update
        this._applyFilters();
        try {
            await this.appClient.rpcClient.call('ThreadRpc.setUserState', {
                threadId,
                preferences: { isStarred: newState }
            });
        } catch (err) {
            this.log.error("Failed to persist star state", err);
            thread.isStarred = !newState; // Rollback
            this._applyFilters();
        }
    }

    isArchived(threadId) {
        const thread = this.allThreads.find(t => t._id === threadId);
        return thread ? !!thread.isArchived : false;
    }
    async toggleArchive(threadId) {
        const thread = this.allThreads.find(t => t._id === threadId);
        if (!thread) return;
        const newState = !thread.isArchived;
        thread.isArchived = newState; // Optimistic update
        this._applyFilters();
        try {
            await this.appClient.rpcClient.call('ThreadRpc.setUserState', {
                threadId,
                preferences: { isArchived: newState }
            });
        } catch (err) {
            this.log.error("Failed to persist archive state", err);
            thread.isArchived = !newState; // Rollback
            this._applyFilters();
        }
    }

    async loadThreads(projectId) {
        if (!projectId && !this.workspace.singleAgentMode) return;
        try {
            const rpcHeaders = projectId ? { projectId } : {};
            const res = await this.appClient.rpcClient.call(
                'ThreadRpc.getData', { pageSize: 200 }, rpcHeaders
            );
            this.allThreads = res.data || [];

            // Populate the client-side ThreadStateStore with pre-existing unread counts
            if (this.workspace.store) {
                this.allThreads.forEach(t => {
                    const state = this.workspace.store.getOrCreate(t._id);
                    if (state) {
                        state.unreadCount = t.unreadCount || 0;
                        state.lastMessagePreview = t.lastMessagePreview || null;
                    }
                });
            }

            this._applyFilters();
        } catch (e) {
            this.log.error('Failed to load threads', e);
        }
    }

    _applyFilters() {
        const q = this.searchQuery.toLowerCase();

        this.filteredThreads = this.allThreads.filter(t => {
            // First, filter by archived status
            const archived = this.isArchived(t._id);
            if (this.activeFilter === 'archived') {
                if (!archived) return false;
            } else {
                if (archived) return false;
            }

            // Filter by category activeFilter: 'all', 'unread', 'direct', 'groups', 'agents', 'starred'
            if (this.activeFilter === 'starred' && !this.isStarred(t._id)) return false;

            if (this.activeFilter === 'unread') {
                const state = this.workspace.store?.get(t._id);
                const unreadCount = state?.unreadCount || t.unreadCount || 0;
                if (unreadCount <= 0) return false;
            }

            const isGroup = t.type === 'group' || t.type === 'ai_human' || (t.members?.length || 0) > 2;
            const isAgent = !isGroup && ((t.members?.length || 0) <= 1 || (t.members || []).some(m => m.participantType === 'agent'));
            const isDirect = !isGroup && !isAgent;

            if (this.activeFilter === 'direct' && !isDirect) return false;
            if (this.activeFilter === 'groups' && !isGroup) return false;
            if (this.activeFilter === 'agents' && !isAgent) return false;

            // Search matching query (matches title, agentName, or any member names)
            if (q) {
                const matchTitle = (t.groupName || t.title || '').toLowerCase().includes(q);
                const matchAgentName = (t.agentName || '').toLowerCase().includes(q);
                const matchMembers = (t.members || []).some(m =>
                    (m.displayName || '').toLowerCase().includes(q) ||
                    (m.username || '').toLowerCase().includes(q)
                );
                return matchTitle || matchAgentName || matchMembers;
            }

            return true;
        });

        // Sort: Pinned first, then chronological lastMessageAt / updatedAt / createdAt
        this.filteredThreads.sort((a, b) => {
            const pinA = this.isPinned(a._id) ? 1 : 0;
            const pinB = this.isPinned(b._id) ? 1 : 0;
            if (pinA !== pinB) return pinB - pinA;

            const timeA = new Date(a.lastMessageAt || a.updatedAt || a.createdAt || 0).getTime();
            const timeB = new Date(b.lastMessageAt || b.updatedAt || b.createdAt || 0).getTime();
            return timeB - timeA;
        });

        this._renderList();
    }

    _renderList() {
        if (!this.listEl) return;
        this.listEl.innerHTML = '';

        if (this.filteredThreads.length === 0) {
            const empty = document.createElement('li');
            empty.className = 'ws-sb-empty';
            empty.innerHTML = `
                <i class="bi bi-chat-square-dots"></i>
                <span>${this.searchQuery ? 'No results found' : 'No conversations yet'}</span>
            `;
            this.listEl.appendChild(empty);
            return;
        }

        // Pinned Group vs Date Grouping
        const pinnedList = this.filteredThreads.filter(t => this.isPinned(t._id));
        const unpinnedList = this.filteredThreads.filter(t => !this.isPinned(t._id));

        let itemDelay = 0;

        // Render Pinned threads group at the top if any exist
        if (pinnedList.length > 0) {
            const groupLi = document.createElement('li');
            groupLi.className = 'ws-sb-group-label';
            groupLi.innerHTML = `<i class="bi bi-pin-angle-fill" style="margin-right: 0.3rem;"></i> Pinned`;
            this.listEl.appendChild(groupLi);

            pinnedList.forEach(thread => {
                this.listEl.appendChild(this._buildItem(thread, itemDelay));
                itemDelay = Math.min(itemDelay + 15, 120);
            });
        }

        // Render date-based groups for unpinned threads
        if (unpinnedList.length > 0) {
            const groups = {};
            unpinnedList.forEach(t => {
                const label = getGroupLabel(t.createdAt || t.updatedAt);
                if (!groups[label]) groups[label] = [];
                groups[label].push(t);
            });

            GROUP_ORDER.forEach(label => {
                if (!groups[label]) return;

                const groupLi = document.createElement('li');
                groupLi.className = 'ws-sb-group-label';
                groupLi.textContent = label;
                this.listEl.appendChild(groupLi);

                groups[label].forEach(thread => {
                    this.listEl.appendChild(this._buildItem(thread, itemDelay));
                    itemDelay = Math.min(itemDelay + 15, 120);
                });
            });
        }
    }

    _buildItem(thread, delayMs) {
        const li = document.createElement('li');
        li.className = 'ws-thread-item' + (this.workspace.currentThreadId === thread._id ? ' active' : '');
        li.style.animationDelay = delayMs + 'ms';
        li.dataset.tid = thread._id;
        li.setAttribute('tabindex', '0');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', this.workspace.currentThreadId === thread._id ? 'true' : 'false');
        li.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.workspace.loadThread(thread._id);
            }
        });

        if (this.editingThreadId === thread._id) {
            const input = document.createElement('input');
            input.type = 'text';
            input.className = 'ws-rename-input';
            input.value = thread.title;
            const save = async () => {
                const v = input.value.trim();
                if (v && v !== thread.title) await this._renameThread(thread._id, v);
                this.editingThreadId = null;
                this._renderList();
            };
            input.addEventListener('keydown', e => {
                if (e.key === 'Enter') save();
                if (e.key === 'Escape') { this.editingThreadId = null; this._renderList(); }
            });
            input.addEventListener('blur', save);
            input.addEventListener('click', e => e.stopPropagation());
            li.appendChild(input);
            setTimeout(() => input.focus(), 0);
            return li;
        }

        const state = this.workspace.store?.get(thread._id);
        const unreadCount = state?.unreadCount || 0;
        const isStreaming = !!state?.isProcessing;

        const isGroup = thread.type === 'group' || thread.type === 'ai_human' || (thread.members?.length || 0) > 2;
        const isAgent = !isGroup && ((thread.members?.length || 0) <= 1 || (thread.members || []).some(m => m.participantType === 'agent'));
        const isDirect = !isGroup && !isAgent;

        const displayTitle = (isGroup && thread.groupName) ? thread.groupName : thread.title;
        const timeStr = formatTime(thread.lastMessageAt || thread.updatedAt || thread.createdAt);
        const preview = thread.lastMessagePreview ? this.escapeHtml(thread.lastMessagePreview.slice(0, 55)) : '';

        // Build avatar using avatarHelper
        let avEl;
        const streamClass = isStreaming ? 'streaming' : '';
        const myUserId = this.appClient.getSharedData('user')?._id || this.appClient.getSharedData('user')?.id;

        if (isAgent) {
            const agentMember = (thread.members || []).find(m => m.participantType === 'agent');
            let agentAvatar = agentMember?.avatarUrl || thread.avatar || thread.avatarUrl || thread.agentAvatar;
            let agentDisplayName = thread.agentName || thread.title || 'Agent';

            const agentName = thread.agentName || agentMember?.participantId;
            if (agentName && this.workspace?.agents) {
                const matchedAgent = this.workspace.agents.find(a => a.name === agentName);
                if (matchedAgent) {
                    if (matchedAgent.avatarUrl) {
                        agentAvatar = matchedAgent.avatarUrl;
                    }
                    if (matchedAgent.name) {
                        agentDisplayName = matchedAgent.name;
                    }
                }
            }

            avEl = avatarHelper.createAvatarElement({
                displayName: agentDisplayName,
                avatarUrl: agentAvatar,
                type: 'agent',
                additionalClasses: ['ws-ti-av', streamClass].filter(Boolean),
                sizeClass: 'default'
            });
        } else if (isGroup) {
            avEl = avatarHelper.createAvatarElement({
                displayName: displayTitle || 'Group',
                avatarUrl: thread.avatar || thread.avatarUrl,
                type: 'group',
                additionalClasses: ['ws-ti-av', streamClass].filter(Boolean),
                sizeClass: 'default'
            });
        } else {
            const other = (thread.members || []).find(m => m.participantType === 'user' && m.participantId !== myUserId);
            const name = other?.displayName || displayTitle || 'User';
            avEl = avatarHelper.createAvatarElement({
                displayName: name,
                avatarUrl: other?.avatarUrl || thread.avatar || thread.avatarUrl,
                type: 'user',
                additionalClasses: ['ws-ti-av', streamClass].filter(Boolean),
                sizeClass: 'default'
            });
        }

        // Build type badge overlay
        let typeBadgeHtml = '';
        if (isAgent) {
            typeBadgeHtml = `<div class="ws-ti-type-badge" title="AI Agent"><i class="bi bi-robot" style="color:var(--bs-primary);"></i></div>`;
        } else if (isGroup) {
            typeBadgeHtml = `<div class="ws-ti-type-badge" title="Group Chat"><i class="bi bi-people-fill" style="color:var(--bs-success);"></i></div>`;
        } else {
            typeBadgeHtml = `<div class="ws-ti-type-badge" title="Direct Message"><i class="bi bi-person-fill" style="color:var(--bs-info);"></i></div>`;
        }

        const pinned = this.isPinned(thread._id);
        const starred = this.isStarred(thread._id);

        const pinHtml = pinned ? `<i class="bi bi-pin-angle-fill ws-ti-pin-icon" title="Pinned"></i>` : '';
        const starHtml = starred ? `<i class="bi bi-star-fill ws-ti-star-icon" title="Starred"></i>` : '';
        const unreadHtml = unreadCount > 0 ? `<div class="ws-ti-unread">${unreadCount}</div>` : '';

        li.innerHTML = `
            <div class="ws-ti-av-container">
                <!-- Avatar dynamically prepended here -->
                ${typeBadgeHtml}
            </div>
            <div class="ws-ti-body">
                <div class="ws-ti-title-row">
                    <span class="ws-ti-title" title="${this.escapeAttr(displayTitle)}">${this.escapeHtml(displayTitle)}</span>
                    <span class="ws-ti-time">${timeStr}</span>
                </div>
                <div class="ws-ti-preview-row">
                    <span class="ws-ti-preview">${preview || this.escapeHtml(thread.agentName || '')}</span>
                    <div class="ws-ti-meta-right">
                        ${pinHtml}
                        ${starHtml}
                        ${unreadHtml}
                        <button class="ws-ti-menu-trigger" title="Options">
                            <i class="bi bi-three-dots-vertical"></i>
                        </button>
                    </div>
                </div>
            </div>
        `;

        const avContainer = li.querySelector('.ws-ti-av-container');
        if (avContainer && avEl) {
            avContainer.insertBefore(avEl, avContainer.firstChild);
        }

        li.addEventListener('click', e => {
            if (e.target.closest('button')) return;
            this.workspace.loadThread(thread._id);
        });

        const menuBtn = li.querySelector('.ws-ti-menu-trigger');
        if (menuBtn) {
            menuBtn.addEventListener('click', e => {
                e.stopPropagation();
                e.preventDefault();

                menuBtn.classList.add('active');

                document.querySelectorAll('.ws-ti-context-menu').forEach(el => el.remove());

                const menu = document.createElement('div');
                menu.className = 'ws-ti-context-menu';

                const cPinned = this.isPinned(thread._id);
                const cStarred = this.isStarred(thread._id);
                const cArchived = this.isArchived(thread._id);

                menu.innerHTML = `
                    <button class="ws-menu-item" id="cmenu-pin">
                        <i class="bi bi-pin-angle${cPinned ? '-slash' : ''}"></i>
                        <span>${cPinned ? 'Unpin' : 'Pin'}</span>
                    </button>
                    <button class="ws-menu-item" id="cmenu-star">
                        <i class="bi bi-star${cStarred ? '-fill' : ''}"></i>
                        <span>${cStarred ? 'Unstar' : 'Star'}</span>
                    </button>
                    <button class="ws-menu-item" id="cmenu-archive">
                        <i class="bi bi-archive${cArchived ? '-fill' : ''}"></i>
                        <span>${cArchived ? 'Unarchive' : 'Archive'}</span>
                    </button>
                    <button class="ws-menu-item" id="cmenu-rename">
                        <i class="bi bi-pencil"></i>
                        <span>Rename</span>
                    </button>
                    <button class="ws-menu-item text-danger" id="cmenu-delete">
                        <i class="bi bi-trash"></i>
                        <span>Delete</span>
                    </button>
                `;

                const rect = menuBtn.getBoundingClientRect();
                const parentRect = this.container.getBoundingClientRect();

                this.container.appendChild(menu);
                const menuHeight = menu.offsetHeight || 165;
                const containerHeight = this.container.clientHeight;

                const spaceBelow = containerHeight - (rect.bottom - parentRect.top);

                let topPos;
                if (spaceBelow < menuHeight && (rect.top - parentRect.top) > menuHeight) {
                    topPos = rect.top - parentRect.top + this.container.scrollTop - menuHeight - 4;
                } else {
                    topPos = rect.bottom - parentRect.top + this.container.scrollTop + 4;
                }

                menu.style.top = `${topPos}px`;
                menu.style.left = `${rect.right - parentRect.left - 140}px`;

                const closeMenu = () => {
                    menu.remove();
                    menuBtn.classList.remove('active');
                    document.removeEventListener('mousedown', onDocClick);
                };

                const onDocClick = (evt) => {
                    if (!menu.contains(evt.target)) {
                        closeMenu();
                    }
                };

                document.addEventListener('mousedown', onDocClick);

                menu.querySelector('#cmenu-pin').addEventListener('click', (evt) => {
                    evt.stopPropagation();
                    this.togglePin(thread._id);
                    closeMenu();
                });
                menu.querySelector('#cmenu-star').addEventListener('click', (evt) => {
                    evt.stopPropagation();
                    this.toggleStar(thread._id);
                    closeMenu();
                });
                menu.querySelector('#cmenu-archive').addEventListener('click', (evt) => {
                    evt.stopPropagation();
                    this.toggleArchive(thread._id);
                    closeMenu();
                });
                menu.querySelector('#cmenu-rename').addEventListener('click', (evt) => {
                    evt.stopPropagation();
                    this.editingThreadId = thread._id;
                    this._renderList();
                    closeMenu();
                });
                menu.querySelector('#cmenu-delete').addEventListener('click', async (evt) => {
                    evt.stopPropagation();
                    closeMenu();
                    if (await this.appClient.notifier.confirm('Delete this conversation?')) {
                        await this._deleteThread(thread._id);
                    }
                });
            });
        }

        return li;
    }

    // ── Public API used by workspace ─────────────────────────────────────────

    addThreadOptimistically(thread) {
        this.allThreads.unshift(thread);
        this._applyFilters();
        this.updateSelection(thread._id);
    }

    updateThreadTitle(threadId, newTitle) {
        const t = this.allThreads.find(th => th._id === threadId);
        if (t) { t.title = newTitle; this._applyFilters(); }
    }

    clearSelection() {
        this.listEl?.querySelectorAll('.ws-thread-item').forEach(el => {
            el.classList.remove('active');
            el.setAttribute('aria-selected', 'false');
        });
    }

    updateSelection(threadId) {
        this.listEl?.querySelectorAll('.ws-thread-item').forEach(li => {
            const active = li.dataset.tid === threadId;
            li.classList.toggle('active', active);
            li.setAttribute('aria-selected', active ? 'true' : 'false');
        });
    }

    updateThreadBadge(threadId, state) {
        // Find the DOM node and update unread count directly to avoid full list re-render
        if (!this.listEl) return;
        const li = this.listEl.querySelector(`.ws-thread-item[data-tid="${threadId}"]`);
        if (!li) return;

        const metaRight = li.querySelector('.ws-ti-meta-right');
        if (!metaRight) return;

        let unreadBadge = metaRight.querySelector('.ws-ti-unread');
        if (state.unreadCount > 0) {
            if (!unreadBadge) {
                unreadBadge = document.createElement('div');
                unreadBadge.className = 'ws-ti-unread';
                const triggerBtn = metaRight.querySelector('.ws-ti-menu-trigger');
                if (triggerBtn) {
                    metaRight.insertBefore(unreadBadge, triggerBtn);
                } else {
                    metaRight.appendChild(unreadBadge);
                }
            }
            unreadBadge.textContent = state.unreadCount;
        } else if (unreadBadge) {
            unreadBadge.remove();
        }

        const av = li.querySelector('.ws-ti-av');
        if (av) {
            av.classList.toggle('streaming', !!state.isProcessing);
        }
    }

    /**
     * In-place preview update — patches text + re-orders the DOM node without
     * tearing down and rebuilding the entire list (_renderList). This avoids
     * the visible flash caused by innerHTML = '' on every incoming message.
     *
     * Falls back to _applyFilters() only when the "Today" group header doesn't
     * yet exist (first message of the day edge-case where list structure changes).
     */
    updateThreadPreview(threadId, previewText, timestamp) {
        // 1. Update the in-memory thread data so future _renderList calls are consistent
        const thread = this.allThreads.find(t => t._id === threadId);
        if (!thread) return;
        thread.lastMessagePreview = previewText;
        thread.lastMessageAt = timestamp || new Date().toISOString();

        if (!this.listEl) return;
        const li = this.listEl.querySelector(`.ws-thread-item[data-tid="${threadId}"]`);
        if (!li) return;

        // 2. Patch preview text in-place
        const previewEl = li.querySelector('.ws-ti-preview');
        if (previewEl) previewEl.textContent = previewText.slice(0, 55);

        // 3. Patch timestamp in-place
        const timeEl = li.querySelector('.ws-ti-time');
        if (timeEl) timeEl.textContent = formatTime(thread.lastMessageAt);

        // 4. Re-order the <li> node to the top of its date group without rebuilding
        // Pinned threads stay in their section — only reorder non-pinned ones
        if (!this.isPinned(threadId)) {
            const allLabels = Array.from(this.listEl.querySelectorAll('.ws-sb-group-label'));
            const todayLabel = allLabels.find(el => el.textContent.trim() === 'Today');

            if (todayLabel) {
                // Move the li to immediately after the Today group header (top of Today group)
                todayLabel.after(li);
            } else {
                // Today group doesn't exist yet (e.g. first message of the day).
                // Structure itself needs to change — full re-render is unavoidable here.
                this._applyFilters();
                return; // _applyFilters already rebuilt badge via _buildItem
            }
        }

        // 5. Refresh the unread badge atomically with the move so the badge always
        //    reflects the current state regardless of call order from the workspace.
        const state = this.workspace?.store?.get(threadId);
        if (state) this.updateThreadBadge(threadId, state);
    }

    updateThreadOptimistically(thread) {
        const idx = this.allThreads.findIndex(t => t._id === thread._id);
        if (idx >= 0) {
            this.allThreads[idx] = { ...this.allThreads[idx], ...thread };
        } else {
            this.allThreads.unshift(thread);
        }
        this._applyFilters();
    }

    // ── Private ──────────────────────────────────────────────────────────────

    async _renameThread(threadId, newTitle) {
        this.updateThreadTitle(threadId, newTitle);
        try {
            await this.appClient.rpcClient.call(
                'ThreadRpc.update',
                { _id: threadId, title: newTitle },
                { projectId: this.workspace.currentProjectId }
            );
        } catch {
            this.appClient.notifier.error('Failed to rename conversation.');
        }
    }

    async _deleteThread(threadId) {
        try {
            await this.appClient.rpcClient.call(
                'ThreadRpc.delete',
                { _id: threadId },
                { projectId: this.workspace.currentProjectId }
            );
            this.allThreads = this.allThreads.filter(t => t._id !== threadId);
            this._applyFilters();
            if (this.workspace.currentThreadId === threadId) {
                this.workspace.startNewThread();
            }
        } catch {
            this.appClient.notifier.error('Failed to delete conversation.');
        }
    }

    // Keep old method names as aliases so workspace code doesn't break
    applyFiltersAndRender() { this._applyFilters(); }
    renderList()            { this._renderList();   }
    async renameThread(id, t) { return this._renameThread(id, t); }
    async deleteThread(id)    { return this._deleteThread(id); }

    _onChatEvent(payload) {
        if (!payload) return;
        // The workspace's _handleChatEventGlobal fires first (registered earlier) and already
        // calls updateThreadPreview(). We delegate to the same method so this handler stays
        // consistent without triggering a second full _applyFilters() rebuild (the flash source).
        if (payload.type === 'new_message' && payload.message) {
            const msg = payload.message;
            const text = (msg.content || '').replace(/[#*`>]/g, '').trim();
            this.updateThreadPreview(msg.threadId, text, msg.createdAt || new Date().toISOString());
        }
        // Refresh thread data on member changes (structural — full rebuild is appropriate here)
        if ((payload.type === 'member_changed') && payload.thread) {
            const updated = payload.thread;
            const idx = this.allThreads.findIndex(t => t._id === updated._id);
            if (idx >= 0) { this.allThreads[idx] = { ...this.allThreads[idx], ...updated }; this._applyFilters(); }
        }
    }

    destroy() {
        this.appClient.events.server.off('chatEvent', this._boundHandleChatEvent);
        this.appClient.events.local.off('AGENT_AVATAR_UPDATED', this._boundHandleAgentAvatarUpdated);
        super.destroy();
    }

    _handleAgentAvatarUpdated() {
        this._applyFilters();
    }

}